import { render, staticRenderFns } from "./MoleculeEditionAcademyInvitations.vue?vue&type=template&id=649e7fd2&"
import script from "./MoleculeEditionAcademyInvitations.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports